import { AlertTriangle } from "lucide-react";

const examples = [
  "Asbestos",
  "Chemicals",
  "Paints and liquids",
  "Gas cylinders",
  "Medical waste",
  "Hazardous materials",
];

const SpecialItems = () => (
  <section className="bg-[#f7f7f7] py-16 md:py-20">
    <div className="container max-w-3xl">
      <div className="rounded-2xl border-2 border-[#1a1a1a]/10 bg-white p-8 md:p-10">
        <div className="w-12 h-12 rounded-full bg-orange/12 flex items-center justify-center mb-5">
          <AlertTriangle className="w-6 h-6 text-orange-deep" />
        </div>
        <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] mb-3">
          Some Items Need Special Arrangements
        </h2>
        <p className="text-[#1a1a1a]/70 mb-7">
          Certain hazardous, regulated or specialised materials may require a different
          disposal method. Examples may include:
        </p>
        <ul className="flex flex-wrap gap-2.5 mb-7">
          {examples.map((e) => (
            <li
              key={e}
              className="rounded-full border border-[#1a1a1a]/12 bg-[#f7f7f7] px-4 py-2 text-sm font-semibold text-[#1a1a1a]/80"
            >
              {e}
            </li>
          ))}
        </ul>
        <p className="font-bold text-[#1a1a1a]">
          If you're unsure, tell us what you've got before booking.
        </p>
      </div>
    </div>
  </section>
);

export default SpecialItems;
